import { render } from "./google-official.vue?vue&type=template&id=859ed494"
import script from "./google-official.vue?vue&type=script&lang=js"
export * from "./google-official.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__